import { fetch } from '@microsoft/portal-app/lib/fetch';
import { isPhoneEmailContacts } from './models';
import {
  actionContactPreferenceAdminFetchError,
  actionContactPreferenceAdminFetchSuccess,
  actionContactPreferenceAdminFetch,
} from '../actions';
import { selectContactPreferenceAdminFetchDisabled } from '../selectors';
import { createThunk } from '../../redux';
import { auth } from '../../auth';
import { topicIds } from '../constants';
import { settingsManager } from '../../shared/settings';

// NOTE: This effect will only get the admin's email preferences saved under
// their account's main email, and will never get the admin's phone
// preferences. This is a limitation of CPM, where the email or phone number
// is a key. In the future, we should either store a lookup table ourselves,
// or get cpm/office to store the table.

export const effectContactPreferenceAdminFetch = createThunk(
  async (dispatch, getState) => {
    if (selectContactPreferenceAdminFetchDisabled(getState())) {
      return;
    }

    const audience = settingsManager.getRequired('cpmAudience');
    const baseUrl = settingsManager.getRequired('cpmBaseUrl');

    dispatch(actionContactPreferenceAdminFetch());

    const user = auth.user;
    const email = user?.email;

    if (!email) {
      dispatch(actionContactPreferenceAdminFetchSuccess());
      return;
    }

    const token = await auth.acquireToken({ scopes: [audience] });
    const response = await fetch(`${baseUrl}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'x-ms-filter-email': email,
      },
    });

    if (response.status === 400) {
      // The admin hasn't saved any contact preference yet. Not sure why this
      // is a 400 and not a 404. A+ API design.
      dispatch(actionContactPreferenceAdminFetchSuccess());
      return;
    } else if (!response.ok) {
      throw Error(`error response from GET ${response.url} (status: ${response.status})`);
    }

    const data = await response.json();

    if (!isPhoneEmailContacts(data)) {
      throw Error(`invalid response from GET ${response.url}`);
    }

    const offersState = data.emailTopicSettings.find((topic) => topic.topicId === topicIds.offers)?.state ?? 'optOut';
    const partnersState =
      data.emailTopicSettings.find((topic) => topic.topicId === topicIds.partners)?.state ?? 'optOut';
    const offersOptIn = offersState !== 'optOut';
    const partnersOptIn = partnersState !== 'optOut';
    const partnersPhoneNumber = data.phoneNumber;
    const partnersEmail = data.email !== email ? data.email : '';

    dispatch(
      actionContactPreferenceAdminFetchSuccess({
        offersOptIn,
        partnersOptIn,
        partnersPhoneNumber,
        partnersEmail,
      }),
    );
  },
  (error, dispatch) => {
    dispatch(actionContactPreferenceAdminFetchError(error));
  },
);
